export default __webpack_public_path__ + "static/media/lubaantunGrid19.666f584a.webp";